import * as React from 'react'

const VehiclePlate = (props: { plate: string }) => {
  return <div className='vehicle-plate-box font-black'>{props.plate}</div>
}

export default VehiclePlate



// WEBPACK FOOTER //
// ./src/components/ui/FormatCarPlate.tsx